<template>
	<div class="status-page">
		<div v-if="this.transferSuccess">
			<div class="container mt-5">
				<header class="mb-4 status-page-header">
					<img src="images/statusPage/ty-success.png" alt="Sukces" style="vertical-align: top" class="mr-4 pb-3" />
					<h1>Dziękujemy!</h1>
				</header>

				<div class="status-page-message">
					<p v-if="transferTypeId === 2">Przelew został wykonany pomyślnie, środki pojawią się na rachunku w ciągu kilku minut.</p>
					<p v-else>
						Dziękujemy za skorzystanie z serwisu Paynow. Po poprawnej weryfikacji transakcji, zlecona kwota wpłaty pojawi sie na Twoim rachunku w mForex w ciągu kilku minut. W razie pytań zachęcamy do kontaktu na
						<a class="btn-link" :href="'mailto:' + cms.footerMail">{{ cms.footerMail }}</a
						>.
					</p>
					<br />
					<router-link to="/Dashboard" class="btn btn-secondary btn-link mb-3">Powrót</router-link>
				</div>
			</div>
		</div>
		<div v-else>
			<div class="container mt-5">
				<header class="mb-4 status-page-header">
					<h1 class="status-page-header">Przelew nie powiódł się</h1>
				</header>
				<div class="status-page-message">
					<p style="margin-bottom: 30px;">
						Niestety, przelew nie został wykonany prawidłowo. Prosimy o
						<a :href="'//' + cms.footerQuestion" class="btn-link" target="_blank">kontakt</a> w celu wyjaśnienia problemu.
					</p>
					<br />
					<router-link to="/Dashboard" class="btn btn-secondary btn-link mb-3">Powrót</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			transferTypeId: null,
			transferSuccess: null,
			/* eslint-disable */
			cms: {
				footerMail: FOOTER_MAIL,
				footerQuestion: FOOTER_QUESTION,
			},
			/* eslint-enable */
		};
	},
	mounted() {
		this.showStatusPage();
	},
	methods: {
		showStatusPage() {
			var q = this.$route.query;
			if (q.success !== undefined) {
				if (Object.entries(q).length === 0 && q.constructor === Object) return;

				this.transferTypeId = parseInt(q.type);
				this.transferSuccess = q.success === 'true' ? true : false;
			}
		},
	},
};
</script>
